var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJava(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8492 24.1235C10.8492 24.1235 9.74734 24.7902 11.6334 25.0158C13.9184 25.287 15.0862 25.2481 17.6042 24.7522C17.6042 24.7522 18.2663 25.1841 19.1908 25.5582C13.546 28.0752 6.41558 25.4124 10.8492 24.1235Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1581 20.8382C10.1581 20.8382 8.92224 21.79 10.8097 21.9931C13.2506 22.2551 15.1782 22.2765 18.5137 21.6083C18.5137 21.6083 18.975 22.0949 19.7005 22.361C12.8756 24.4374 5.27392 22.5248 10.1581 20.8382Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9732 15.2657C17.3641 16.9317 15.6078 18.4309 15.6078 18.4309C15.6078 18.4309 19.1395 16.5341 17.5175 14.1588C16.0027 11.9437 14.841 10.8431 21.1298 7.04844C21.1298 7.04844 11.2585 9.6135 15.9732 15.2657Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4399 26.5525C23.4399 26.5525 24.2553 27.2515 22.5418 27.7923C19.2836 28.8192 8.98071 29.1293 6.11862 27.8332C5.08976 27.3676 7.01915 26.7213 7.62606 26.5857C8.25901 26.4429 8.62072 26.4695 8.62072 26.4695C7.47653 25.6309 1.22516 28.1162 5.44533 28.8279C16.9544 30.7698 26.4252 27.9535 23.4399 26.5525Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3785 17.4355C11.3785 17.4355 6.13777 18.7305 9.52261 19.2008C10.9518 19.3999 13.8008 19.3549 16.4546 19.1235C18.6235 18.9332 20.8013 18.5285 20.8013 18.5285C20.8013 18.5285 20.0365 18.8692 19.4832 19.2623C14.1614 20.7185 3.88056 20.041 6.84027 18.5515C9.34331 17.2927 11.3785 17.4355 11.3785 17.4355Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7808 22.9029C26.1908 19.9781 23.6894 17.1674 21.9435 17.5461C21.5156 17.6387 21.3248 17.719 21.3248 17.719C21.3248 17.719 21.4837 17.4601 21.7871 17.348C25.241 16.0847 27.8973 21.0742 20.6721 23.0503C20.6721 23.0503 20.7558 22.9725 20.7808 22.9029Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5183 0.921387C17.5183 0.921387 20.5143 4.03962 14.6766 8.83457C9.99532 12.6809 13.6091 14.874 14.6747 17.3798C11.9421 14.8147 9.93679 12.5567 11.2821 10.4551C13.2567 7.37018 18.7271 5.8745 17.5183 0.921387Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9113 30.8278C17.1042 31.1737 25.0784 30.636 25.2672 28.0796C25.2672 28.0796 24.9042 29.0487 20.9756 29.8183C16.5434 30.6861 11.0769 30.5848 7.83472 30.0286C7.83472 30.0286 8.49844 30.6001 11.9113 30.8278Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJava);
export default __webpack_public_path__ + "static/media/java.f14aa4d098bc804bb2a71fa56aa9d271.svg";
export { ForwardRef as ReactComponent };